import ScolabSwitcher from '../components/Switcher';
import { resolveAsJson, getBundlePath, resolveInjection, waitFor } from '../utils/utils';

document.addEventListener("DOMContentLoaded", () => {
    ScolabSwitcher
        .configure({
            id: "publisher",
            environmentName: "QA @ master",
            s3: [{
                bucket: 'scolab-publisher-artifacts',
                subfolder: 'deployments',
                key: 'branch',
                defaultSelection: 'master__latest',
                onArtifactSelect: (publisherBranch: string, branchVersion: string) => {
                    const condition = () => window.Workbook !== undefined;
                    const onReady = async () => {
                        const publisherCdn = `https://d1nl5n7c9mdisg.cloudfront.net/deployments/${publisherBranch}/`;
                        const publisherManifest = await resolveAsJson(`${publisherCdn}${branchVersion}/assets-manifest.json`);
                        const publisher = `${publisherCdn}${publisherManifest['main.js']}`;
                        localStorage.setItem("PublisherBundlesPath", getBundlePath(publisher));
                        [
                            `${publisherCdn}${publisherManifest['vendors.js']}`,
                            publisher,
                        ].map(resolveInjection);
                    };

                    void waitFor(condition, onReady).catch(error => {
                        console.error('Unable to load the Publisher bundle.', error);
                    });
                }
            }, {
                bucket: 'workbook-artifacts',
                key: 'wbk',
                defaultSelection: 'master__latest',
                onArtifactSelect: async (workbookBranch: string, branchVersion: string) => {
                    const workbookCdn = `https://di22ilrkkvt8k.cloudfront.net/${workbookBranch}/`;
                    const workbookManifest = await resolveAsJson(`${workbookCdn}${branchVersion}/assets-manifest.json`);
                    const workbook = `${workbookCdn}${workbookManifest['embed.js']}`;
                    localStorage.setItem("WorkbookBundlesPath", getBundlePath(workbook));
                    [
                        `${workbookCdn}${workbookManifest['vendors.js']}`,
                        workbook,
                    ].map(resolveInjection);
                }
            }],
        })
        .mount();
});